import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { AuctionService } from '@services/auction/auction.service';
import { ReportService } from '@services/report/report.service';
import { UserService } from '@services/user/user.service';
import { environment } from '../../../environments/environment';
import { SharedService } from '@services/shared/shared.service';
import { DataTableDirective } from 'angular-datatables';
import { Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { individualWinner } from '@/helpers/constant';
import { TitleService } from '@services/title.service';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss'],
})
export class ReportsComponent implements OnInit {
  transform(value: string): string {
    return value ? value.replace(/_/g, ' ') : value;
  }
  @ViewChildren(DataTableDirective) DT: QueryList<DataTableDirective>;

  public winnerList: object[] = [];
  public env: string = environment.forntend_url;
  public imgUrl: string = '';
  public imgBaseUrl: string = environment.imgBaseUrl;
  public fallBackImg: string;
  public userFallBackImg: string;
  public loading: boolean = false;
  public approveStatus: boolean | null;
  public checkingValue = [null, true, false];
  public dtOptions: any = {};
  public individualAuctions: object[] = [];
  public individualBatchAuctions: object[] = [];
  public bulkAuctions: object[] = [];
  public individualLadda: boolean = false;
  public bulkLadda: boolean = false;
  public headingOrder = individualWinner;

  constructor(
    public userService: UserService,
    public auctionService: AuctionService,
    public reportService: ReportService,
    public sharedService: SharedService,
    private router: Router,
    private titleService: TitleService
  ) {
    this.titleService.updateTitle('Auction Purchase Request');
    this.fallBackImg = this.env + 'assets/img/car-placeholder.png';
    this.userFallBackImg = this.env + 'assets/img/user-placeholder.png';

    this.dtOptions = {
      bLengthChange: false,
      bInfo: false,
      bPaginate: false,
      bSortable: false,
      dom: 'Bfrtip',
      columnDefs: [{ orderable: false, targets: '_all' }],
      buttons: ['csv', 'excel'],
    };
  }

  ngOnInit(): void {
    this.getWinnerList();
  }

  getWinnerList(): void {
    this.loading = true;

    this.userService.getWinnerList().subscribe(
      (res: { data: object[]; message: string; success: boolean }) => {
        if (res['success'] === true) {
          this.loading = false;
          this.separateAuction(res['data']);
        }
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
      }
    );
  }

  vehicleName() {
    this.individualAuctions.forEach((item: object, index: number) => {
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'Description'
      ];
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'description'
      ];
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'Finance status'
      ];
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'Finance Status'
      ];
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'test_drive_video'
      ];
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'Test Drive Video'
      ];
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'vehicle_360_link'
      ];
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'Vehicle 360 link'
      ];
      delete item?.['auction_information']?.[0]?.['description_data']?.[
        'price'
      ];
      this.individualAuctions[index]['vehicleName'] =
        this.sharedService.InventoryName(
          item['auction_information'][0]?.['description_data']
        );
    });
  }

  updateStatus(auctionId: string, status: string): void {
    this.auctionService.updateStatus(auctionId, status).subscribe((res) => {
      if (res['success'] === true) {
        window.location.reload();
      }
    });
  }

  batchVehicleNo(batch: object[]) {
    batch.forEach((item, index) => {
      this.individualBatchAuctions[index]['numberOfVehicle'] =
        item['auction_information']?.[0]['ProductInfo']?.length;
    });
  }

  bulkVehicleNo(bulk: object[]) {
    bulk.forEach((item, index) => {
      this.bulkAuctions[index]['numberOfVehicle'] =
        item['auction_information'][0]['bulkInfo'][0]['ProductInfo'].length;
    });
  }

  separateAuction(auctions: object[]) {
    auctions.forEach((auction) => {
      if (
        auction['auction_information'][0]['entity_type'] === 'individual' &&
        auction['auction_information'][0]['description_data']
      ) {
        this.individualAuctions.push(auction);
      } else if (
        auction['auction_information'][0]['entity_type'] === 'individual_batch'
      ) {
        this.individualBatchAuctions.push(auction);
      } else if (auction['auction_information'][0]['entity_type'] === 'group') {
        this.bulkAuctions.push(auction);
      }
    });
    this.vehicleName();
    this.batchVehicleNo(this.individualBatchAuctions);
    this.bulkVehicleNo(this.bulkAuctions);
  }

  recycleIndividualAuction(auctionId: string) {
    this.individualLadda = true;

    this.reportService.vehicleRecycle(auctionId).subscribe((res) => {
      if (res['success']) {
        this.router.navigate([`/dashboard/auction/edit/${auctionId}`]);
      }
    });
  }

  recycleBulkAuction(auctionId: string) {
    this.bulkLadda = true;

    this.reportService.vehicleRecycle(auctionId).subscribe((res) => {
      if (res['success']) {
        this.router.navigate([`/dashboard/auction/edit/${auctionId}`], {
          queryParams: { type: 'bulk' },
        });
      }
    });
  }
}

@Pipe({ name: 'removeUnderscore' })
export class RemoveUnderscorePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value.replace(/_/g, ' ');
  }
}
